jQuery(document).ready(function($){
 
	
	// set up form validation and ajax submit
	
	var slider = $(".bxslider");

	if (slider.length){
		$(document).ready(function(){
		  $('.bxslider').bxSlider({
				controls: false,
				auto: true,
				autoStart: true,
            	speed: 1000
		  });
		});
	}
  
  	var navMainOpen = false;
  
  	function navMainToggle(){

		if (!navMainOpen){

			//var ulHeight = $('#mainNav').find('ul').outerHeight();

			//nav.addClass('navOpen');

			$('#mainNav .mobileMenuIcon').addClass('expanded').blur();
          	$('#mainNav ul').removeClass('mobileMenuHide').blur();
          	$('#mainNav ul').addClass('mobileMenuShow').blur();

			navMainOpen = true;

		} else {

			//nav.removeClass('navOpen');

			$('#mainNav .mobileMenuIcon').removeClass('expanded').blur();
          	$('#mainNav ul').addClass('mobileMenuHide').blur();
          	$('#mainNav ul').removeClass('mobileMenuShow').blur();

			navMainOpen = false;

		}

	};

  
  	$('#mainNav .mobileMenuIcon').click(function(e){

		e.preventDefault();

		navMainToggle();

		//navHeight();

	});
  
  	var navProdOpen = false;
  
  	function navProdToggle(){

		if (!navProdOpen){

			//var ulHeight = $('#mainNav').find('ul').outerHeight();

			//nav.addClass('navOpen');

			$('#productsNav .mobileMenuIcon').addClass('expanded').blur();
          	$('#productsNav ul').removeClass('mobileMenuHide').blur();
          	$('#productsNav ul').addClass('mobileMenuShow').blur();

			navProdOpen = true;

		} else {

			//nav.removeClass('navOpen');

			$('#productsNav .mobileMenuIcon').removeClass('expanded').blur();
          	$('#productsNav ul').addClass('mobileMenuHide').blur();
          	$('#productsNav ul').removeClass('mobileMenuShow').blur();

			navProdOpen = false;

		}

	};

  
  	$('#productsNav .mobileMenuIcon').click(function(e){

		e.preventDefault();

		navProdToggle();

		//navHeight();

	});



	var contactForm = $("#contactForm");
	
	if (contactForm.length){
	
		contactForm.validate({
			//friendly error messages
			//delete or comment out for those fields that are not required
			rules: {
				phone: {
					phoneUS: true
				}
			},
			messages: {
				name: "Please enter your name",
				email: "Please enter a valid email address",
				phone: "Please enter a valid phone number",
				message: "Please enter your message"
			},
			submitHandler: function(form) {
				$.ajax({
					url: 'common/includes/contactProcess.php',
					type: 'post',
					data: contactForm.serialize(),
					success: function() {
						$('#sentMessage').remove();
						contactForm.before('<section id="sentMessage" class="sentMessage"><h2>Your message has been sent!</h2><p>Thanks for your interest! We&rsquo;ll get back to you soon.</p></section>');
						// clear out the form fields
						contactForm.find('input, textarea').not(':input[type=submit]').each(function(){
							$(this).val('');
						});
						
					}            
				});
			}
		});
		
	}

  
  	//$('#productAlt').html($('#productPhotoImg').attr('alt'));
  	  
  	$('li img.thumbimg').click( function() {
      $('#productPhotoImg').attr('src', $(this).attr('src'));
      $('#productAlt').html($(this).attr('alt'));
  	});
  

});